export default __webpack_public_path__ + "static/media/les_andelys01.a9e2d90a.jpg";